<template>
  <div id="WarehouseProductsList" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
      <div class="col-12 lh40 bg-color-white pl5 pr5 bb1">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary" v-if="$store.state.app_args.cate_name == ''"><span class="f24 fw">A</span><img src="" alt="" srcset="">lmacén</div>
        <div class="col-6 t-c color-primary" v-else>{{ $store.state.app_args.cate_name }} <i class="iconfont icon-error color-muted" @click="del_page_args()"></i></div>
        <div class="col-3 t-r f22 pr3"></div>
      </div>
      <div class="col-12 bg-color-white pl10 pr10 pt5 pb5">
        <div class="col-4 f14 uppercase color-muted pt8 pb8" @click="go_cate">Categorías <i class="iconfont icon-arrow-down-filling color-muted"></i></div>
        <div class="col-8">
          <div class="col-12 bg-color1 pt8 pb8 pl10 r5">
            <i class="iconfont icon-search color-muted"></i>
            <input type="text" class="w-80 bg-color1" v-model="keyword" @keyup.enter="get_list_data()">
            <i class="iconfont icon-error color-muted" @click="clearKeyword()"  v-if="keyword"></i>
          </div>
        </div>
      </div>
      <div class="col-12 bg-color1 pt5 pb5 pl10 pr10 f12">
        <div class="col-3 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':$store.state.app_args.product_status == 1,'color-muted':$store.state.app_args.product_status != 1}" @click="statusCh(1)">Todo</div>
        <div class="col-3 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-success color-white':$store.state.app_args.product_status == 2,'color-muted':$store.state.app_args.product_status != 2}" @click="statusCh(2)">En stock</div>
        <div class="col-3 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-warning color-white':$store.state.app_args.product_status == 3,'color-muted':$store.state.app_args.product_status != 3}" @click="statusCh(3)">Ojo</div>
        <div class="col-3 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-danger color-white':$store.state.app_args.product_status == -1,'color-muted':$store.state.app_args.product_status != -1}" @click="statusCh(-1)">Agotado</div>
      </div>
    </div>
    <div class="h12"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 pl5 pr5 mt5" v-for="(product,product_i) in data_list" v-bind:key="product_i" @click="go_product(product_i)">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-2 f40 color-primary t-c">
                <img v-bind:src="product.pic" v-if="product.pic" class="w5 h5">
                <img src="@/assets/goods.jpg" v-else class="w5">
              </div>
              <div class="col-9 pl10">
                <div class="col-12 f12 uppercase">{{ product.product_code }}</div>
                <div class="col-12 f14 fw uppercase pb2 el1">{{ product.product_name }}</div>
                <div class="col-12 color-muted f14">
                  <div class="col-3"> [<span class="f12">1 x </span><span class="color-black">{{ fun.formatMoney(product.package,2,'.',',',true) }}</span>] </div>
                  <div class="col-9">
                    <span class="f12 ml10">En existencia:</span>
                    <span class="" :class="{'color-danger': product.qty <= 0,'color-success': product.qty > 0 && product.qty - product.qty_min > 0,'color-warning': product.qty > 0 && product.qty - product.qty_min <= 0}"> 
                      <span v-if="product.qty > 0" class="fw">{{ Math.floor(product.qty / product.package) }}</span>
                      <span v-else class="fw">{{ fun.formatMoney(product.qty,2,'.',',',true) }}</span>
                      <span class="color-muted" v-if="product.qty > 0 && product.package > 1"> Bulto </span>
                      <span v-if="product.qty % product.package > 0 && product.package > 1">+ {{ product.qty % product.package }}<span class="color-muted"> u</span></span>
                      <span v-else><span class="color-muted"> u</span></span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-1 color-muted t-r lh50"><i class="iconfont icon-31fanhui2"></i></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 t-c pt10 pb10">
      <page-component :page-config="pageConfigTotal" @changeCurrentPage="changePage"></page-component>
    </div>
  </div>
</template>
<script>
import pageComponent from "../pageComponent"
export default {
  name: 'WarehouseProductsList',
  data () {
    return {
      keyword: '',
      data_list: [],
      data_page: 1,
      pageConfigTotal:{total:0,pageSize:20,pageNo:1},
    }
  },
  created: function () {
    if(this.$store.state.app_args.product_keyword != ''){
      this.keyword = this.$store.state.app_args.product_keyword;
    }
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      if(this.keyword != ''){
        this.$store.commit('setAppArgs',{product_keyword: this.keyword});
      }
      var post_data = {};
      post_data.keyword = this.$store.state.app_args.product_keyword;
      post_data.page = this.$store.state.app_args.product_page - 1;
      post_data.status = this.$store.state.app_args.product_status;
      post_data.cate_id = this.$store.state.app_args.cate_id;
      if(post_data.page < 0){
        post_data.page = 0;
      }
      this.post(this.api_url + 'manage/warehouse_products', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.products;
          console.log(res.data);

          this.pageConfigTotal.total = res.data['products_count'];
        }else{
          this.data_list = []
        }
      })
    },
    changePage(page){
      this.pageConfigTotal.pageNo = page
      this.$store.commit('setAppArgs',{product_page: page});
      this.get_list_data();
    },
    statusCh(status){
      if(this.$store.state.app_args.product_status == status){
        return;
      }
      this.$store.commit('setAppArgs',{product_status: status, product_page: 1});
      this.get_list_data();
    },
    go_cate(){
      this.$router.push({name:'M_ProductCateList'});
    },
    del_page_args(){
      this.$store.commit('setAppArgs',{cate_id: '', cate_name: ''});
      this.get_list_data();
    },
    go_product( product_i ){
      this.$router.push({name:'M_Product',query:{from:this.$route.name, id: this.data_list[product_i].id, stock_id: this.data_list[product_i].warehouse_stock_id}});
    },
    clearKeyword(){
      this.keyword = '';
      this.$store.commit('setAppArgs',{product_keyword: ''});
      this.get_list_data();
    },

  },
  components:{'page-component':pageComponent}
}
</script>



// WEBPACK FOOTER //
// src/components/Main/WarehouseProductsList.vue